import { apiService } from "@/_services";
import router from "@/router";

const authentication = JSON.parse(localStorage.getItem("authentication"));

const initialState = authentication
  ? { status: { loggedIn: true }, user: authentication.user }
  : { status: { loggedIn: false }, user: null };

export default {
  namespaced: true,
  state: initialState,

  getters: {
    loggedIn(state) {
      return !!state.status.loggedIn;
    },
    loggingIn(state) {
      return !!state.status.loggingIn;
    }
  },

  actions: {
    login({ dispatch, commit }, { username, password }) {
      commit("loginRequest", { username });
      let loginRequest = apiService.auth.login(username, password);
      loginRequest.then(
        authentication => {
          if (authentication.token) {
            localStorage.setItem(
              "authentication",
              JSON.stringify(authentication)
            );
            dispatch("setAccount", authentication.user);
            router.push({ name: "home" });
          }
        },
        err => {
          commit("loginFailure", err);
          if (
            {}.hasOwnProperty.call(err, "errors") &&
            {}.hasOwnProperty.call(err.errors, "rest_jwt_auth_failure")
          ) {
            let errors = err.errors.rest_jwt_auth_failure;
            if (
              Object.prototype.toString.call(errors) == "[object Array]" &&
              errors.length
            ) {
              this._vm.$toast.open({
                duration: 5000,
                message: errors[0],
                type: "is-danger"
              });
            }
          }
        }
      );
    },
    setAccount({ commit }) {
      let authentication = JSON.parse(localStorage.getItem("authentication"));
      commit("loginSuccess", authentication.user);
    },
    unsetAccount({ commit }) {
      localStorage.removeItem("authentication");
      commit("logout");
    },
    logout({ dispatch }) {
      dispatch("config/unsetConfig", null, { root: true });
      dispatch("unsetAccount");
      router.push({ name: "login" });
    }
  },

  mutations: {
    loginRequest(state, user) {
      state.status = { loggingIn: true };
      state.user = user;
    },
    loginSuccess(state, user) {
      state.status = { loggedIn: true };
      state.user = user;
    },
    loginFailure(state) {
      state.status = { loggedIn: false };
      state.user = null;
    },
    logout(state) {
      state.status = { loggedIn: false };
      state.user = null;
    }
  }
};
